import React, { useState } from "react";
import {
  Popover as initialPopover,
  Chip,
  Icon,
  RadioGroup,
  Radio,
  Input,
  Button,
  Typography,
  DatePicker,
  Dropdown,
} from "@plum-xoxo/admin-dsm";

import moment from "moment";
import cloneDeep from "lodash/cloneDeep";

function ApplyFilterModal(props) {
  const {
    columns: initialColumns,
    index = 0,
    applyFilter,
    showClear = true,
    selectedFilterIndex,
    title,
    type,
    removeSelectedTags,
  } = props;
  const disableInput = selectedFilterIndex > -1;
  const [columns, setColumns] = useState(initialColumns);
  const column = columns?.length > 0 ? cloneDeep(columns[index]) : null;

  const [datePickerPopperRef, setDatePickerPopperRef] = useState("");

  const getCustomIcon = () => {
    return <Icon iconName="PlumCalendar" color="dark" shade="c200" size="s" />;
  };

  const clearFilter = (column) => {
    let filters = column?.filter?.filters;
    let filterType = column?.filter?.filterType;
    switch (filterType) {
      case "input":
      case "inputNumber":
        filters.map((ele) => {
          if (ele.selected) {
            ele.value = "";
            ele.inputNumber = false;
          }
        });
        break;
      case "select":
        filters?.value
          ? ((filters.value = ""), (filters.selectInputSelected = false))
          : null;
        break;
      case "date":
        if (filters?.startDate && filters?.endDate) {
          filters.startDate = null;
          filters.endDate = null;
          filters.dateSelected = false;
        }
        break;
    }
    let index = columns.findIndex((header) => header.name === column.name);
    const newColumns = [...columns];
    newColumns[index] = column;
    setColumns(newColumns);
  };

  const showApplyFilterBtn = (column) => {
    let filters = column?.filter?.filters;
    let filterType = column?.filter?.filterType;
    switch (filterType) {
      case "input":
      case "inputNumber": {
        const newFilters = filters?.filter((ele) => ele.selected);
        if (newFilters && newFilters[0]?.value) {
          return true;
        }
        return false;
      }
      case "select":
        return filters?.value ? true : false;
      case "date": {
        if (filters?.startDate && filters?.endDate) {
          return true;
        }
        return false;
      }

      default:
        return "";
    }
  };

  const renderFilterContent = (column) => {
    let filterContent = "";
    const { filterType } = column.filter || {};
    switch (filterType) {
      case "input":
        filterContent = renderInputFilter(column);
        break;
      case "inputNumber":
        filterContent = renderInputFilter(column, true);
        break;
      case "date":
        filterContent = renderDateFilter(column);
        break;
      case "select":
        filterContent = renderSelectFilter(column);
        break;
    }
    return filterContent;
  };

  const handleDateFilterChange = (tag, value, column) => {
    switch (tag) {
      case "startDate":
        column.filter.filters.startDate = moment(value).format("YYYY-MM-DD");
        break;
      case "endDate":
        column.filter.filters.endDate = moment(value).format("YYYY-MM-DD");
        break;
      default:
        break;
    }
    // if (tag === "startDate" && !column.filter.filters.endDate) {
    //   column.filter.filters.endDate = column.filter.filters.startDate;
    // }
    if (tag === "endDate" && !column.filter.filters.startDate) {
      column.filter.filters.startDate = column.filter.filters.endDate;
    }
    let index = columns.findIndex((header) => header.name === column.name);
    const newColumns = [...columns];
    newColumns[index] = column;
    setColumns(newColumns);
  };

  const handleSelectFilterChange = (value, column) => {
    column.filter.filters.value = value;
    let index = columns.findIndex((header) => header.name === column.name);
    const newColumns = [...columns];
    newColumns[index] = column;
    setColumns(newColumns);
  };

  const handleInputFilterChange = (
    type,
    newValue,
    item,
    column,
    numberOnly
  ) => {
    let { filter: { filters = [] } = {} } = column;
    switch (type) {
      case "radio":
        filters.map((filter) => {
          if (filter.operation === item.operation) {
            filter.selected = true;
            filter.value = "";
          } else {
            filter.selected = false;
            filter.value = "";
          }
        });
        break;
      case "input":
        filters.map((filter) => {
          if (filter.operation === item.operation) {
            filter.value = numberOnly ? newValue.replace("-", "") : newValue;
          } else {
            filter.value = "";
          }
        });
        break;
    }
    let index = columns.findIndex((header) => header.name === column.name);
    const newColumns = [...columns];
    newColumns[index] = column;
    setColumns(newColumns);
  };

  const renderInputFilter = (column, numberOnly = false) => {
    return column?.filter?.filters?.map((item, index) => {
      return (
        <>
          {column?.filter?.filters?.length === 1 ? (
            ""
          ) : (
            <RadioGroup direction="column">
              <Radio
                label={item?.operation?.toString().toLowerCase()}
                value={item.operation}
                checked={item.selected}
                name={item?.operation}
                disabled={disableInput}
                onChange={(e) => {
                  handleInputFilterChange(
                    "radio",
                    e.target.value,
                    item,
                    column
                  );
                }}
              />
            </RadioGroup>
          )}
          <Input
            label=""
            placeholder={
              item.operation === "contains"
                ? column.label === "Recipient Name"
                  ? "Enter keyword"
                  : "Enter " + column.label
                : column.label === "Reward Sent"
                ? "Enter Amount"
                : "Enter " + column.label
            }
            type={numberOnly ? "number" : "text"}
            disabled={!item.selected || disableInput}
            value={numberOnly ? item.value.replace("-", "") : item.value}
            className="mb-8"
            min={0}
            onChange={(e) => {
              handleInputFilterChange(
                "input",
                e.target.value,
                item,
                column,
                numberOnly
              );
            }}
          />
        </>
      );
    });
  };

  const renderDateFilter = (column) => {
    let {
      filter: {
        value = "",
        filters: { operation = "", startDate = "", endDate = "" } = {},
      } = {},
    } = column;
    let daysCount;
    if (
      title === "reward points" ||
      title === "reward code" ||
      title === "reward link"
    ) {
      daysCount = 365;
    } else if (
      title === "gift cards" ||
      (title === "payments" && type !== "empuls_report")
    ) {
      daysCount = 180;
    }
    const startDateIsOutsideRange = (date) => {
      if (endDate) {
        if (moment(endDate) < moment(date)) {
          return true;
        }
      }
      if (Math.abs(moment(date).diff(moment(), "days")) > daysCount) {
        return true;
      }
      if (moment(date) > moment()) {
        return true;
      }
      return false;
    };

    const endDateIsOutsideRange = (date) => {
      if (startDate) {
        if (moment(startDate) > moment(date)) {
          return true;
        }
      }
      if (Math.abs(moment(date).diff(moment(), "days")) > daysCount) {
        return true;
      }
      if (moment(date) > new Date()) {
        return true;
      }
      return false;
    };

    return (
      <div>
        <Typography.LabelText color="dark" shade="c200">
          {value?.toString()}
        </Typography.LabelText>
        <DatePicker
          inputFormat="dd/MM/yyyy"
          label={
            <Typography.LabelText color="dark" shade="c300" className="py-8">
              From
            </Typography.LabelText>
          }
          value={startDate}
          placeholder="Start Date"
          onChange={(value) => {
            handleDateFilterChange("startDate", value, column);
          }}
          shouldDisableDate={(day) => startDateIsOutsideRange(day)}
          PopperProps={{
            container: datePickerPopperRef,
          }}
          defaultCalendarMonth={endDate ? new Date(endDate) : new Date()}
          components={{
            OpenPickerIcon: getCustomIcon,
          }}
          disabled={disableInput}
        />
        <DatePicker
          inputFormat="dd/MM/yyyy"
          label={
            <Typography.LabelText color="dark" shade="c300" className="py-8">
              To
            </Typography.LabelText>
          }
          value={endDate}
          placeholder="End Date"
          onChange={(value) => {
            handleDateFilterChange("endDate", value, column);
          }}
          shouldDisableDate={(day) => endDateIsOutsideRange(day)}
          PopperProps={{
            container: datePickerPopperRef,
          }}
          defaultCalendarMonth={startDate ? new Date(startDate) : new Date()}
          components={{
            OpenPickerIcon: getCustomIcon,
          }}
          disabled={disableInput}
        />
      </div>
    );
  };

  const renderSelectFilter = (column) => {
    const {
      label,
      filter: {
        filters: { operation = "", options = [], value = "" } = {},
      } = {},
    } = column;
    return (
      <>
        <Dropdown
          placeholder={
            <Typography color="dark" shade="c100" className="mb-0">
              Select {label}
            </Typography>
          }
          options={options}
          value={value}
          disabled={disableInput}
          onChange={(value) => {
            handleSelectFilterChange(value, column);
          }}
        />
      </>
    );
  };

  const renderApplyFilter = (column) => {
    return (
      <div className="mt-20 d-flex justify-content-between align-items-center">
        <div>
          {showClear && (
            <Typography.ButtonText
              color="red"
              shade="c200"
              className="mr-12 cursor-pointer"
              onClick={() => {
                removeSelectedTags(column);
              }}
            >
              Clear
            </Typography.ButtonText>
          )}
        </div>
        <div className="d-flex">
          <Button
            variant="plain"
            color="primary"
            className="mr-12"
            onClick={() => {
              document.body.click();
            }}
          >
            Cancel
          </Button>
          <Button
            color="primary"
            onClick={() => applyFilter(columns)}
            disabled={!showApplyFilterBtn(column) || disableInput}
          >
            Apply filter
          </Button>
        </div>
      </div>
    );
  };

  return column ? (
    <div
      className={`p-24 mr-8 ${
        column?.filter?.filterType === "date" ? "date-picker-container" : ""
      }`}
      onClick={() => {
        setDatePickerPopperRef(
          document.querySelector(".date-picker-container")
        );
      }}
    >
      <Typography.LabelText color="dark" shade="c200" className="mb-8">
        {column.label}
      </Typography.LabelText>
      {renderFilterContent(column)}
      {renderApplyFilter(column)}
    </div>
  ) : null;
}

export default ApplyFilterModal;
